import React from "react";
import { Route as ReactDOMRoute, Redirect } from "react-router-dom";

import { useAuth } from "../hooks/auth";
import { nodeMatchesPermission, rotaInicial } from "./products";
import SemAcesso from "./SemAcesso";
import { comNext, destinoDe, lerNext } from "../utils/nextSeguro";

// `authorized` (PO1-2381, épico PO1-2374): guard de URL. Uma rota que declara
// permissão (a mesma string ou lista do item de menu em routes/products.js) só
// renderiza a tela se nodeMatchesPermission aceitar — a MESMA regra de
// filterMenuForUser (admin Everlog tem bypass; lista = qualquer uma libera).
// Senão mostra "Sem acesso" no lugar da tela, em vez de redirecionar em
// silêncio. Rotas sem `authorized` continuam abrindo como sempre.
export function usuarioPodeAcessar(user, authorized) {
  if (!authorized) return true;
  if (!user) return false;
  return nodeMatchesPermission({ authorized }, user.permissions || [], user.setor === "admin");
}

const Route = ({ component: Component, isPrivate, isPublic, authorized, ...rest }) => {
  const { user } = useAuth();
  let signed = false;

  if (user) {
    signed = true;
  }

  // PO1-3391 (P3): quem chega deslogado num link do app (ex.: o Extrato do
  // pedido de análise, vindo do e-mail) vai para o login com ?next=<destino> e
  // volta para lá depois de entrar. Só caminhos /app/ são aceitos (nextSeguro).
  if (!signed && isPrivate) {
    return <Redirect to={comNext("/auth/login", destinoDe(rest.location))} {...rest} />;
  }
  // Rotas públicas (ex: /public/cotacao-spot/:token, links acessados por
  // transportadoras a partir de email) não redirecionam mesmo se o user
  // estiver logado — caso contrário um operador logado clicaria no link e
  // cairia no /app/autopilot ao invés do form que quer preencher.
  // PO1-3106/PO1-2287: a aterrissagem é única (rotaInicial): habilitação →
  // painel; transportadora → Minhas faturas; os demais → Autopilot.
  // PO1-3391: com ?next= seguro na URL, o destino pedido vence a aterrissagem.
  if (signed && !isPrivate && !isPublic) {
    const next = lerNext(rest.location && rest.location.search);
    return <Redirect to={next || rotaInicial(user)} {...rest} />;
  }
  // PO1-2381: guard de URL. A rota continua casando no <Switch> (mesmo path),
  // mas a tela dá lugar à página "Sem acesso".
  if (signed && !usuarioPodeAcessar(user, authorized)) {
    return <ReactDOMRoute {...rest} render={() => <SemAcesso permissao={authorized} />} />;
  }
  return (
    <ReactDOMRoute {...rest} render={(props) => <Component {...props} />} />
  );
};

export default Route;
